import React, { useContext } from "react";
import { useState, useEffect } from "react";
// import "../../Tabels/Tabels.css";
import { Link } from "react-router-dom";
import { Context } from "../../../utils/context";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
// *******************toster****************************
import Select from "react-select";
import ModalSave from "../../common/ModelSave";

import { CancelButton, SaveButton } from "../Button";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { Row, Col, Form, InputGroup, Modal } from "react-bootstrap";
import { useForm, Controller } from "react-hook-form";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PasswordChecklist from "react-password-checklist";
import classNames from "classnames";
import "./Passwordchange.css";
library.add(fas);

const PasswordChange = (props) => {
    const { postData, getData, Select2Data } = useContext(Context);

    const id = props.show;

    const [showModal, setShowModal] = useState({
        code: 0,
        message: "",
    });

    const {
        control,
        register,
        handleSubmit,
        formState: { errors },
        reset,
        setError,
        setValue,
        getValues,
        clearErrors,
    } = useForm();

    const onSubmit = async (data) => {
        if (password !== passwordCurrent) {
            if (password === passwordAgain) {
                const res = await postData(`/common/auth/change-password`, data);
                if (res?.success) {
                    // props.handleClose();
                    reset();
                    setPassword("");
                    setPasswordCurrent("");
                    setPasswordAgain("");

                    await setShowModal({ code: res.code, message: res.data });
                    setTimeout(() => {
                        setShowModal({
                            code: 0,
                            message: "",
                        });

                        props.onHide();
                    }, 2000);

                    // hideModalWithDelay();
                    // passwordClose()
                } else {
                    if (res?.errors) {
                        setError("current_password", { message: res?.errors });
                    }
                    if (res?.message?.errors?.current_password) {
                        setError("current_password", {
                            message: res?.message?.errors?.current_password?.msg,
                        });
                    }
                }
            } else {
                setError("current_password", { message: "Password must match" });
            }
        } else {
            setError("current_password", {
                message: "Current Password and New Password Not Same",
            });
        }
    };

    const [showPasswordCurrent, setShowPasswordCurrent] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [showPasswordOne, setShowPasswordOne] = useState(false);
    const [iconOne, setIconOne] = useState(faEyeSlash);
    const [iconTwo, setIconTwo] = useState(faEyeSlash);
    const [iconCurrent, setIconCurrent] = useState(faEyeSlash);

    const togglePasswordVisibility = (field) => {
        if (field === "password") {
            setShowPassword(!showPassword);
            setIconOne(showPassword ? faEyeSlash : faEye);
        } else if (field === "reenterPassword") {
            setShowPasswordOne(!showPasswordOne);
            setIconTwo(showPasswordOne ? faEyeSlash : faEye);
        } else if (field === "current_password") {
            setShowPasswordCurrent(!showPasswordCurrent);
            setIconCurrent(showPasswordCurrent ? faEyeSlash : faEye);
        }
    };
    const [password, setPassword] = useState("");
    const [passwordCurrent, setPasswordCurrent] = useState("");
    const [passwordAgain, setPasswordAgain] = useState("");
    return (
        <>
            <Modal
                {...props}
                onHide={props.onHide}
                size="md"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                className="change-pass-modal"
            >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        Change Password
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form
                        onSubmit={handleSubmit(onSubmit)}
                        role="form"
                    // className="stateclass"
                    >
                        <Row className="justify-content-center">
                            <Col md={12}>
                                <div className="main-form-section my-3">
                                    <Form.Group>
                                        <div className="">
                                            <Form.Label>Current Password*</Form.Label>
                                        </div>
                                        <InputGroup>
                                            <div className="formfieldMain">
                                                <Form.Control
                                                    type={showPasswordCurrent ? "text" : "password"}
                                                    placeholder="Enter Current Password*"
                                                    {...register("current_password", {
                                                        required: "Current Password is required",
                                                    })}
                                                    onChange={(e) => {
                                                        setPasswordCurrent(e.target.value);
                                                        if (e.target.value) {
                                                            clearErrors("current_password");
                                                        }
                                                    }}
                                                // {...register("current_password")}
                                                />
                                                <FontAwesomeIcon
                                                    className="eyeIcon"
                                                    icon={iconCurrent}
                                                    onClick={() =>
                                                        togglePasswordVisibility("current_password")
                                                    }
                                                />
                                            </div>
                                        </InputGroup>
                                        {errors?.current_password && (
                                            <span className="text-danger">
                                                {errors?.current_password?.message}
                                            </span>
                                        )}
                                    </Form.Group>
                                </div>
                            </Col>

                            <Col md={12}>
                                <div className="main-form-section my-3">
                                    <Form.Group>
                                        <div className="">
                                            <Form.Label>New Password*</Form.Label>
                                        </div>
                                        <InputGroup>
                                            <div className="formfieldMain">
                                                <Form.Control
                                                    type={showPassword ? "text" : "password"}
                                                    placeholder="Enter New Password*"
                                                    {...register("new_password", {
                                                        required: "New Password is required",
                                                    })}
                                                    onChange={(e) => {
                                                        setPassword(e.target.value);
                                                        if (e.target.value) {
                                                            clearErrors("new_password");
                                                        }
                                                    }}
                                                />
                                                <FontAwesomeIcon
                                                    icon={iconOne}
                                                    className="eyeIcon"
                                                    onClick={() => togglePasswordVisibility("password")}
                                                />
                                            </div>
                                        </InputGroup>
                                        {errors.new_password && (
                                            <span className="text-danger">
                                                {errors.new_password.message}
                                            </span>
                                        )}
                                    </Form.Group>
                                </div>
                            </Col>
                            <Col md={12}>
                                <div className="main-form-section my-3">
                                    <Form.Group>
                                        <div className="">
                                            <Form.Label>Confirm Password*</Form.Label>
                                        </div>
                                        <InputGroup>
                                            <div className="formfieldMain">
                                                <Form.Control
                                                    type={showPasswordOne ? "text" : "password"}
                                                    placeholder="Re Enter New Password*"
                                                    {...register("re_password", {
                                                        required: "Re Enter New Password",
                                                    })}
                                                    onChange={(e) => {
                                                        setPasswordAgain(e.target.value);
                                                        if (e.target.value) {
                                                            clearErrors("re_password");
                                                        }
                                                    }}
                                                />
                                                <FontAwesomeIcon
                                                    icon={iconTwo}
                                                    className="eyeIcon"
                                                    onClick={() =>
                                                        togglePasswordVisibility("reenterPassword")
                                                    }
                                                />
                                            </div>
                                        </InputGroup>
                                        {password && passwordAgain && (
                                            <PasswordChecklist
                                                rules={["match"]}
                                                value={password}
                                                valueAgain={passwordAgain}
                                                onChange={(isValid) => { }}
                                                style={{
                                                    fontSize: "10px",
                                                    padding: "4px",
                                                    margin: "0",
                                                }}
                                            />
                                        )}
                                        {errors.re_password && (
                                            <span className="text-danger">
                                                {errors.re_password.message}
                                            </span>
                                        )}
                                    </Form.Group>
                                </div>
                            </Col>

                            <Row className="mt-5 pb-3">
                                <div className="d-flex justify-content-center">
                                    <Link>
                                        <CancelButton name={"cancel"} handleClose={props.onHide} />
                                    </Link>

                                    <SaveButton
                                        name={"save"}
                                        handleSubmit={handleSubmit(onSubmit)}
                                    />
                                </div>
                            </Row>
                        </Row>
                    </Form>
                </Modal.Body>
            </Modal>

            <ModalSave
                message={showModal.message}
                showErrorModal={showModal.code ? true : false}
            />
        </>
    );
};

export default PasswordChange;